export type Error404Props = unknown

export const ERROR_404_GLOBAL_ID = 'error-404'
